export var BagPrice;
(function (BagPrice) {
    BagPrice[BagPrice["SMALL"] = 300] = "SMALL";
    BagPrice[BagPrice["LARGE"] = 500] = "LARGE";
})(BagPrice || (BagPrice = {}));
export var BagStatus;
(function (BagStatus) {
    BagStatus["ACTIVE"] = "active";
    BagStatus["SOLD_OUT"] = "sold_out";
    BagStatus["EXPIRED"] = "expired";
})(BagStatus || (BagStatus = {}));
